import type { AcceptedTreatmentPlanDraft } from "./treatmentPlanTypes";
import type { TreatmentModality } from "./plan.types";

type AcceptedPlanModality = Extract<TreatmentModality, "ivf" | "iui" | "fet">;

/**
 * Resolve the treatment family selected in the persisted accepted plan.
 *
 * Unlike resolvePlannedModality, this is a source-of-truth lookup: when a
 * record exists but is undecided, it deliberately returns null instead of
 * falling back to exploratory modalities or inferring IVF.
 */
export function resolveAcceptedPlanModality(
  plan: Pick<AcceptedTreatmentPlanDraft, "treatmentFamily"> | null | undefined,
): AcceptedPlanModality | null {
  switch (plan?.treatmentFamily) {
    case "ivf":
    case "iui":
    case "fet":
      return plan.treatmentFamily;
    default:
      return null;
  }
}
